import axios, { type ResponseType } from "axios";
import { API_BASE_URL } from "@/common/config";
import { isSerializable } from "@/models/Serializable";

export abstract class APIService {
  protected readonly apiBaseUrl = API_BASE_URL;

  public readonly get = async (url: string) => {
    return axios.get(this.apiBaseUrl + url, {
      withCredentials: true,
    });
  };

  public readonly post = async (url: string, data: unknown, responseType: ResponseType = "json") => {
    let dataToSend = isSerializable(data) ? data.toJSON() : data;
    dataToSend = await Promise.resolve(dataToSend);
    return axios.post(this.apiBaseUrl + url, dataToSend, {
      responseType,
      withCredentials: true,
    });
  };

  public readonly put = async (url: string, data: unknown) => {
    const dataToSend = isSerializable(data) ? data.toJSON() : data;
    return axios.put(this.apiBaseUrl + url, dataToSend, {
      withCredentials: true,
    });
  };

  public readonly delete = async (url: string) => {
    return axios.delete(this.apiBaseUrl + url, {
      withCredentials: true,
    });
  };

  public readonly putAway = async (url: string, data: unknown) => {
    const payload = JSON.stringify(isSerializable(data) ? data.toJSON() : data);
    fetch(this.apiBaseUrl + url, {
      method: "PUT",
      body: payload,
      keepalive: true,
      credentials: "include", // Include cookies
      headers: {
        "Content-Type": "application/json",
        "x-set-cookie": "true",
      },
    });
  };
}
